import { lazy } from 'react'

import { useTranscriptMetadata } from 'src/contexts/Transcript/MetadataContext'
import { useVerbitConnect } from 'src/contexts/VerbitConnectWrapperContext'
import { getMixpanelApiKey, getRollbarToken } from 'src/utils/env'

const rollbarToken = getRollbarToken()
const mixpanelToken = getMixpanelApiKey()

export const MediaRecorder = lazy(() => import('@verbit-ai/verbit-connect-web').then((module) => ({ default: module.MediaRecorder })))

const LazySource = lazy(() => import('@verbit-ai/verbit-connect-web/media-source').then((module) => ({ default: module.MediaSource })))
export const MediaSource = () => {
    const metadata = useTranscriptMetadata()
    const { isMediaSourceViewMode } = useVerbitConnect()

    return (
        <LazySource
            orderId={metadata?.orderId || ''}
            isViewer={isMediaSourceViewMode}
            rollbarToken={rollbarToken}
            mixpanelToken={mixpanelToken}
        />
    )
}

export const MediaPlayerToggle = lazy(() => import('@verbit-ai/verbit-connect-web/player-toggle'))
export const MediaPlayer = lazy(() => import('@verbit-ai/verbit-connect-web/player'))
